  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>
        {{'COMMON.forgotPassword' | translate}}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismissModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
<ion-content>
  <ion-row>
    <ion-grid>
      <ion-col size="10">
        <p>{{'COMMON.forgotPasswordDescription' | translate}}</p>
        <sol-input
          [(ngModel)]="email"
          icon="mail-outline"
          [fullWidth]="true"
          label="E-mail"
          [clearInput]="true"
          [inputType]="inputType.EMAIL"
          [editMode]="true"
          [placeHolder]="'COMMON.emailEnterEmail' | translate"
        ></sol-input>
      </ion-col>
      <ion-col size="2">
        <ion-button
          size="block"
          (click)="onSubmitPasswordReset()">{{'COMMON.resetPassword' | translate}}</ion-button>
      </ion-col>
    </ion-grid>
  </ion-row>
</ion-content>
